<template>
  <a-layout-content style="padding: 0 50px">
    <a-breadcrumb style="padding: 16px 0">
      <a-breadcrumb-item v-for="data in breadcrumbs" :key="data.name">{{data.title}}</a-breadcrumb-item>
    </a-breadcrumb>
    <a-layout style="padding: 24px 0; background: #fff">
      <a-layout-sider width="200" style="background: #fff">
        <a-menu
          mode="inline"
          :openKeys.sync="openKeys"
          :selectedKeys.sync="selectedKeys"
          style="height: 100%"
          @click="onMenuChange"
        >
          <a-sub-menu v-for="data in menus" :key="data.name">
            <span slot="title">
              <a-icon :type="data.icon" />
              {{data.title}}
            </span>
            <a-menu-item v-for="item in data.children" :key="item.name">{{item.title}}</a-menu-item>
          </a-sub-menu>
        </a-menu>
      </a-layout-sider>
      <a-layout-content :style="{ padding: '0 24px', minHeight: '280px' }">
        <router-view />
      </a-layout-content>
    </a-layout>
  </a-layout-content>
</template>
 
<script>
import { menus } from "../../config/menus";
export default {
  components: {},
  data() {
    return {
      menus,
      openKeys: menus.map((v) => v.name),
      selectedKeys: [],
      breadcrumbs: [],
    };
  },
  methods: {
    onMenuChange(menu) {
      if (menu.key == this.$route.name) {
        return;
      }
      console.info("menu", menu.key);
      this.$router.push({ name: menu.key });
    },
    makeMenuStatus() {
      const { name } = this.$route;
      menus.forEach((menu) => {
        if (menu && Array.isArray(menu.children)) {
          const selected = menu.children.find((v) => v.name == name);
          if (selected) {
            // this.openKeys.push(menu.name);
            this.selectedKeys = [selected.name];
            this.breadcrumbs = [menu, selected];
          }
        }
      });
    },
  },
  mounted() {
    if (this.$store.state.user.token) {
      this.$nextTick(this.makeMenuStatus);
    } else {
      this.$router.replace("/");
    }
  },
  watch: {
    $route(route) {
      this.makeMenuStatus();
    },
  },
};
</script>
